/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_DueInputs */

const en_sort_due = /** @type {(inputs: Sort_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due date`)
};

const de_sort_due = /** @type {(inputs: Sort_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fälligkeit`)
};

/**
* | output |
* | --- |
* | "Due date" |
*
* @param {Sort_DueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_due = /** @type {((inputs?: Sort_DueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_DueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_due(inputs)
	return en_sort_due(inputs)
});